import { apiInstances } from '../../../../libs';

const { patch } = apiInstances.ratingInstance;

export default async function patchRating({ idRating, payload }) {
  return patch(`/ratings/${idRating}`, payload);
}
